<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="color_hex" class="form-label">Color:</label>
                    <input id="color_hex" class="form-control" name="color_hex" v-model="formData.color_hex" :class="checkValidation(classes)" type="color">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'tag'
const url = 'tag'
export default {
  name: 'roomBaseAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      selectData: [],
      formData: {
        title_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getData: page + '/getData'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
